import api from '../api';

const BASE_URL = '/api/v2/redactors';

const RedactorsAPI = {
	listRedactors: (params) => api.get(BASE_URL, { params }),
	createRedactor: (data) => api.post(BASE_URL, data),
	updateRedactor: (id, data) => api.patch(`${BASE_URL}/${id}`, data),
	updateRedactorPassword: (id, data) => api.patch(`${BASE_URL}/${id}/password`, data),
	deleteRedactor: (id) => api.delete(`${BASE_URL}/${id}`),
	updateRadios: (id, data) => api.patch(`${BASE_URL}/${id}/update-radios`, data),
	getRedactorRadios: (id) => api.get(`${BASE_URL}/${id}/get-radios`),
};

export default RedactorsAPI;
